function monthByUTC(d = new Date()) {
  const m = d.getUTCMonth() // 0–11
  // Возвращаем название месяца на английском для использования в CSS переменных
  const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
  return monthNames[m]
}

function applyMonthColor() {
  const root = document.documentElement
  const month = monthByUTC()
  const defaultVarName = `--blue-default-color-${month}`
  const defaultVal = getComputedStyle(root).getPropertyValue(defaultVarName).trim()

  const lightVarName = `--blue-light-color-${month}`
  const lightVal = getComputedStyle(root).getPropertyValue(lightVarName).trim()
  if (defaultVal && lightVal) {
    root.style.setProperty('--blue-default-color-season', defaultVal)
    root.style.setProperty('--blue-light-color-season', lightVal)
    return true
  }
  return false
}

export function applySeasonSettings() {
  // Попытка сразу
  if (applyMonthColor()) {
    return
  }

  // Подстраховка: подождём загрузки ресурсов (CSS) и пару кадров
  const deadline = Date.now() + 2000 // максимум ~2с «догоняем» стили

  function tick() {
    if (applyMonthColor()) {
      return
    }
    if (Date.now() > deadline) {
      return
    } // перестаём пытаться
    requestAnimationFrame(tick)
  }

  if (document.readyState === 'complete') {
    tick()
  } else {
    window.addEventListener('load', () => requestAnimationFrame(tick), { once: true })
    requestAnimationFrame(tick) // вдруг всё уже готово
  }
}

/**
 * Определяет месяц транзакции с учетом вычитания 12 часов для reset транзакций
 * @param transactionDate - Дата транзакции (строка или Date)
 * @param bonusComment - Комментарий бонуса (для определения reset транзакций)
 * @returns Название месяца на английском (january, february, etc.)
 */
export function getTransactionMonth(transactionDate: string | Date, bonusComment?: string): string {
  const date = typeof transactionDate === 'string' ? new Date(transactionDate) : transactionDate
  let transactionTime = date.getTime()

  // Для транзакций с комментарием "monthly bonus reset" вычитаем 12 часов
  if (bonusComment && bonusComment.toLowerCase().includes('monthly bonus reset')) {
    transactionTime -= 12 * 60 * 60 * 1000 // вычитаем 12 часов в миллисекундах
  }

  const adjustedDate = new Date(transactionTime)
  return monthByUTC(adjustedDate)
}

/**
 * Возвращает CSS переменные цвета для конкретного месяца транзакции
 * @param transactionDate - Дата транзакции (строка или Date)
 * @param bonusComment - Комментарий бонуса (для определения reset транзакций)
 * @returns Объект с CSS переменными для цвета месяца транзакции
 */
export function getTransactionMonthColors(transactionDate: string | Date, bonusComment?: string) {
  const month = getTransactionMonth(transactionDate, bonusComment)
  return {
    defaultColor: `var(--blue-default-color-${month})`,
    lightColor: `var(--blue-light-color-${month})`,
  }
}
